import { Grid } from "@chakra-ui/react"
import SchedulesTotal from "./SchedulesTotal"
import SchedulesAverage from "./SchedulesAverage"

const Charts = () => {
	return (
		<Grid
			w="full"
			templateColumns={{ sm: "1fr", md: "repeat(2, 1fr)" }}
			gap="12px"
		>
			<SchedulesAverage />
			<SchedulesTotal />
		</Grid>
	)
}

export default Charts
